import { render, staticRenderFns } from "./Tva.vue?vue&type=template&id=abc8f3b2&"
import script from "./Tva.vue?vue&type=script&lang=ts&"
export * from "./Tva.vue?vue&type=script&lang=ts&"
import style0 from "./Tva.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports